<template>
  <Theform type="Sign in"></Theform>
</template>

<script>
import Theform from '@/components/Theform.vue';

export default {
  components: { Theform },

}
</script>